import { mallEntranceApi } from '../request'
import { apiPath } from '../api'

export const primeCard = {
  primeCardBenefits: data =>
    mallEntranceApi.post(apiPath.primeCardBenefits, data),
  primeCardSavingDetail: data =>
    mallEntranceApi.post(apiPath.primeCardSavingDetail, data),
  primeCardOrderList: () => mallEntranceApi.post(apiPath.primeCardOrderList),
  primeCardOrderDetail: data =>
    mallEntranceApi.post(apiPath.primeCardOrderDetail, data),
  primeCardPrePay: data => mallEntranceApi.post(apiPath.primeCardPrePay, data)
}
